export default "__VITE_ASSET__fd0391c7__"